<odx-modal-header>
  <odx-area-header i18n="@@modal.generalConfirmation.header">Dateiformat wird nicht unterstützt</odx-area-header>
</odx-modal-header>
<odx-modal-content>
  <p>{{ modalRef.data.text }}</p>
</odx-modal-content>
<odx-modal-footer>
  <button odxButton variant="primary" (click)="onConfirm()" i18n="@@modal.generalConfirmation.button.confirm">OK</button>
</odx-modal-footer>
